import { IFormulaFieldDataModel } from '../formula-field.data-model';
import { FieldDefinition, fieldDefinitionSchema } from './field-definition.schema';

/**
 * Inbound mapper: formula field row → canonical `FieldDefinition` for the
 * Field Manager "All" view. Terminates in `fieldDefinitionSchema.cast(...)`
 * per the FD-2794 cross-cutting rule.
 */
export function formulaFieldToFieldDefinition(ff: IFormulaFieldDataModel): FieldDefinition {
  return fieldDefinitionSchema.cast(
    {
      key: ff.key,
      displayName: ff.displayName,
      description: ff.description || undefined,
      type: ff.type,
      format: ff.format ?? undefined,
      sortOrder: 0,
      isActive: true,
      createdAt: ff.createdAt ?? '',
      updatedAt: ff.updatedAt ?? '',
    },
    { stripUnknown: true }
  ) as FieldDefinition;
}
